<template>
  <div>
    <p class="text-2xl mb-6">
      Suivi des articles produits par IA
      <dag-info
        :dags="[
          'adn_daily_posts_sites_infos_dag',
          'adn_get_and_store_ia_posts_stats_daily_dag',
        ]"
      />
    </p>

    <v-card class="mb-6 pa-2" outlined>
      <v-row class="ma-3">
        <v-col cols="12">
          <filters></filters>
        </v-col>
      </v-row>
    </v-card>

    <v-row v-if="page.dataForStats.length > 0">
      <v-col cols="12" md="12">
        <ga-stats-by-date-chart :data="page.dataForStats" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12">
        <results-table @dataUpdated="setDataForStats" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { reactive, onMounted } from "@vue/composition-api";

import DagInfo from "@/components/common/menus/DagInfo";

import Filters from "@/components/ai-factory/suivi-prod-ia/filters/Filters.vue";
import GaStatsByDateChart from "@/components/ai-factory/suivi-prod-ia/cards/GaStatsByDateChart.vue";
import ResultsTable from "@/components/ai-factory/suivi-prod-ia/tables/Results.vue";

import useProxy from "@/hooks/useProxy";
import { saveRmraView } from "@/utils/rmr-analytics";

export default {
  name: "SuiviProdIA",
  components: {
    DagInfo,
    Filters,
    GaStatsByDateChart,
    ResultsTable,
  },
  setup(props, { emit }) {
    const { route } = useProxy();

    const page = reactive({
      dataForStats: [],
    });

    // =>  METHODS
    const setDataForStats = (data) => {
      page.dataForStats = data;
    };

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS
    onMounted(async () => {
      saveRmraView(route);
    });

    // =>  DATA
    return {
      page,
      setDataForStats,
    };
  },
};
</script>

<style scoped></style>
